import { useInfiniteQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { bookmarkKeys, listBookmarks, removeBookmark } from '../../entities/bookmark';

export const useBookmarks = () => {
  const client = useQueryClient();

  const list = useInfiniteQuery({
    queryKey: bookmarkKeys.list,
    queryFn: ({ pageParam }) => listBookmarks(pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (last) => last.nextCursor ?? undefined,
  });

  const remove = useMutation({
    mutationFn: removeBookmark,
    onSuccess: () => client.invalidateQueries({ queryKey: bookmarkKeys.all }),
  });

  return { list, remove };
};

export type TBookmarks = ReturnType<typeof useBookmarks>;
